// homepage 移动端导航栏
// $(".template-index .header").addClass("homeHeadBg")
$(window).scroll(function(){
  if ($(window).scrollTop() > 10) {
      $(".template-index .header").addClass("homeHeadBg")
  } else{
      $(".template-index .header").removeClass("homeHeadBg")
  }
})

// 产品详情 table 切换
$(function(){
  $(".product-tabs-body-item ul.tabs>li").click(function(){
    if (window.screen.width > 1024) {
      $('html,body').animate({scrollTop:$('.product-tabs-body').offset().top + 50 }, 800);
    }else{
      $('html,body').animate({scrollTop:$('.product-tabs-body').offset().top }, 800);
    }
  })
})


// contact-form
setTimeout(()=>{
  $(".cs_addForm .form_box .select-wrapper").attr("class","").find(".selected-text").hide()
},500)
// $('#productModel').multipleSelect({
//     selectAll:false,
//     placeholder:''
// }).change(function(){
//     $(this).val() ? $(this).val().join(',') : ''
// })
$(".cs_contactButton button").click(function(e){
   let name = $("#name").val()
   let phone = $("#phone").val()
   let email = $("#email").val()
   var emailInvalid = /^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}(\.[a-zA-Z]{2,6})?)$/;
  if(name == ''){
    $(".cs_addForm .name").addClass("noRequired")
  }else{
    $(".cs_addForm .name").removeClass("noRequired")
  }
   if(phone == ''){
    $(".cs_addForm .phone").addClass("noRequired")
  }else{
    $(".cs_addForm .phone").removeClass("noRequired")
  }
  if(email == ''){
    $(".cs_addForm .email").addClass("noRequired")
  }else{
    $(".cs_addForm .email").removeClass("noRequired")
  }
  
  if($(".cs_addForm form div").hasClass("noRequired")){
    return false
  }else{
    if(emailInvalid.test(email) == false){
      $(".cs_addForm .email").addClass("invalid")
      return false;
    }else{
      $(".cs_addForm .email").removeClass("invalid")
      $(".cs_addForm form").submit()
      // 提交成功
      $(".form_success").css("display","flex")
      setTimeout(function(){
		$(".form_success").find("h3").text("Successfully submitted")
		$(".form_success").addClass("form_successFul").find("p").text("The form has been submitted and Peter is expected to respond to you within 8 hours. If you want to communicate via WhatsApp, please click the button above.")
		$(".form_successFul button").click(function(){
            $(".form_success").removeClass("form_successFul")
            $(".form_success").hide()
            document.getElementById("contact_form").reset()
		})
      },1000)
    }
  }
});
$(".form_success section i").click(function(){
  $(".form_success").removeClass("form_successFul")
  $(".form_success").hide()
  document.getElementById("contact_form").reset()
})

// max4T&max4N page add section
// let pageUrl = window.location.href
// if(pageUrl.search("max-4n") != -1 || pageUrl.search("max-4t") != -1){
//   $(".product-inventory").after(`<div class="showFormPopups"><img src="https://cdn.shopify.com/s/files/1/0047/0247/0190/files/Banner-577x83-img.png?v=1710298474"/></div>`)
// }

// formPopups 
$(".showFormPopups img").click(function(){
  $("#shopify-section-cs-add-formPopups").css("display","flex")
  let productName = $("h1.product-title").text()
  $("#productName").val(productName)
})
$(".formPopups_close").click(function(){
  $("#shopify-section-cs-add-formPopups").hide()
})
$(".formPopups_button button").click(function(e){
   let name = $("#name").val()
   let phone = $("#phone").val()
   let email = $("#email").val()
   var emailInvalid = /^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}(\.[a-zA-Z]{2,6})?)$/;
  if(name == ''){
    $(".formPopups_menu .name").addClass("noRequired")
  }else{
    $(".formPopups_menu .name").removeClass("noRequired")
  }
   if(phone == ''){
    $(".formPopups_menu .phone").addClass("noRequired")
  }else{
    $(".formPopups_menu .phone").removeClass("noRequired")
  }
  if(email == ''){
    $(".formPopups_menu .email").addClass("noRequired")
  }else{
    $(".formPopups_menu .email").removeClass("noRequired")
  }
  
  if($(".formPopups_menu div").hasClass("noRequired")){
    return false
  }else{
    if(emailInvalid.test(email) == false){
      $(".formPopups_menu .email").addClass("invalid")
      return false;
    }else{
      $(".formPopups_menu .email").removeClass("invalid")
      $(".formPopups_main form").submit()
      // 提交成功
      setTimeout(function(){
        $(".formPopups").addClass("formPopups_success")
		$(".formPopups_success .formPopups_title").find("h1").text("Successfully submitted")
		$(".formPopups_success .formPopups_title").find("p").text("We will get back to you via email later.")
      },1000)
    }
  }
});

// product faq
$('.FAQsRight .Section span').click(function() {
  $(".FAQsRight .Section span").removeClass('iconTransform')
  $(this).parent().find('.panel-content').slideToggle(function(){
      if($(this).parent().find('.panel-content').is(':visible')){
        $(this).parent().find('span').addClass('iconTransform')
        $(this).parent().siblings().find('.panel-content').slideUp()
        $(this).parents(".panel").siblings().find('.panel-content').slideUp()
      }else{
        $(this).parent().find('span').removeClass('iconTransform')
      }
  });
})
$('.FAQsRight .Section span').each(function() {
  $(this).next('.panel-content').hide()
})
$('.FAQsLeft ul li').click(function() {
  let faqIndex = $(this).index() + 1
  $('html,body').animate({
      scrollTop: $('.FAQsRight .panel:nth-child(' + faqIndex + ')').offset().top - 1
  }, 800);
});

// blog gasp
gsap.registerPlugin(ScrollTrigger); // 引入滚动插件
	gsap.timeline()
	.fromTo('.aniSectionH3',{opacity:'0'},{opacity:'1',
        scrollTrigger:{  // 配置滚动参数
            trigger: '.aniSectionH3', // 滚动时控制的元素
            scrub: true, // 启用滚动条关联
			start: 'top 70%',
			end: 'top 15%',
        },
		onComplete: () => { // 动画完成回调
			$(".aniSectionH3").css('opacity','0')
			$(".aniSection").css({
				'box-shadow':'none',
				'paddding':0,
			})
		},
	})
	.fromTo('.aniSection',{boxShadow:'0'},{
		boxShadow:'0 2.7px 5.4px rgba(0, 0, 0, .052), 0 7.5px 15px rgba(0, 0, 0, .075), 0 18.1px 36.2px rgba(0, 0, 0, .098), 0 60px 120px rgba(0, 0, 0, .15)',
		scrollTrigger:{  // 配置滚动参数
			trigger: '.aniSection', // 滚动时控制的元素
			scrub: true, // 启用滚动条关联
			start: 'top 80%',
			end: 'top 15%',
		},
	})